module.exports = __webpack_public_path__ + "fonts/Simple-Line-Icons.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Simple-Line-Icons.woff2
// module id = 285
// module chunks = 0